export default "__VITE_ASSET__Mb0frhfA__"